import { h, Component } from "preact";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";

export class DashboardExport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creatingSheet: false,
    };
  }
  createGoogleSheet() {
    this.setState({ creatingSheet: true });
    window.gapi.client.load("sheets", "v4", () => {
      window.gapi.client.sheets.spreadsheets
        .create({
          properties: {
            title: `Dashboard export of ${new Date().toLocaleDateString()}`,
          },
        })
        .then(response => {
          let values = [];
          this.props.dashboardData.forEach(user => {
            user.entries.forEach(entry => {
              values.push([
                `${user.first_name} ${user.last_name}`,
                entry.rating,
                entry.description,
                entry.date,
              ]);
            });
          });
          window.gapi.client.sheets.spreadsheets.values
            .append({
              spreadsheetId: response.result["spreadsheetId"],
              range: "Sheet1",
              insertDataOption: "INSERT_ROWS",
              valueInputOption: "USER_ENTERED",
              resource: {
                values: [["User", "Rating", "Description", "Date"]].concat(
                  values
                ),
              },
            })
            .then(response => {
              this.setState({ creatingSheet: false });
              toast("Export created on Google Drive");
              window.open(
                `https://docs.google.com/spreadsheets/d/${
                  response.result["spreadsheetId"]
                }`
              );
            })
            .catch(error => {
              this.setState({ creatingSheet: false });
              toast("Something went wrong");
              console.error(error);
            });
        })
        .catch(error => {
          this.setState({ creatingSheet: false });
          toast("Something went wrong");
          console.error(error);
        });
    });
  }
  render() {
    return (
      <Button
        loading={this.props.dashboardData && this.state.creatingSheet}
        disabled={this.props.dashboardData && this.state.creatingSheet}
        onClick={() => this.createGoogleSheet()}
      >
        <Icon name="external alternate" />
        Export to Google Sheets
      </Button>
    );
  }
}

export default DashboardExport;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-export/DashboardExport.js